/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Table } from 'antd'

import Loading from '../../../components/Loaders/Loading'
import { paginationItemRender } from '../../../utils/table'

import { createKeysCollectionColumns, fetchCollection } from '../utils'

function KeyNestSection (props) {
  const { city, params, setParams, setTotalCount, setTotalLoading } = props

  const [loading, setLoading] = React.useState(true)
  const [page, setPage] = React.useState(1)
  const [total, setTotal] = React.useState(0)
  const [data, setData] = React.useState([])

  const fetchKeysCollection = signal => {
    fetchCollection(
      { city, page, ...params },
      signal,
      setData,
      setTotal,
      setLoading,
      setTotalCount,
      setTotalLoading,
      'getKeysCollection'
    )
  }

  React.useEffect(() => {
    const controller = new AbortController()

    fetchKeysCollection(controller.signal)

    return () => {
      controller.abort()
    }
  }, [city, page, params])

  return (
    <div className="pt-7">
      {loading
        ? <Loading />
        : (
          <div>
            <Table
              loading={loading}
              dataSource={data}
              columns={createKeysCollectionColumns()}
              scroll={{ x: 900 }}
              sticky={{ offsetHeader: 45 }}
              pagination={{
                current: page,
                pageSize: params.pageSize,
                total,
                showSizeChanger: true,
                itemRender: paginationItemRender,
                onChange: (nextPage, nextLimit) => {
                  if (nextPage !== page) {
                    setPage(nextPage)
                  }

                  if (nextLimit !== params.pageSize) {
                    setPage(1)
                    setParams(prev => ({ ...prev, pageSize: nextLimit }))
                  }
                }
              }}
              rowKey="_id"
            />
          </div>
        )}
    </div>
  )
}

export default KeyNestSection
